import { Button } from '@/components/ui/button'
import * as Card from '@/components/ui/card'
import { Heading } from '@/components/ui/heading'
import { Text } from '@/components/ui/text'
import { useAuth } from '@stateApp'
import 'cropperjs/dist/cropper.min.css'
import { ScanSearch } from 'lucide-solid'
import { type Setter, Show } from 'solid-js'
import { useService } from 'solid-services'
import { Grid } from 'styled-system/jsx'

export default function (props: {
  setIsOpen: Setter<boolean>
}) {
  const { isRifleman, isRecruit } = useService(useAuth)()
  const canAccessHvfTool = () => !isRifleman() && !isRecruit()

  return (
    <Card.Root p='3' bg='gray.1'>
      <Grid
        gridTemplateColumns={{
          base: '1fr',
          mdToXl: '1fr auto',
        }}
        justifyContent="space-between"
        alignItems="center"
      >
        <Grid gap={2}>
          <Heading>Price Data Extractor</Heading>
          <Text textStyle="sm">
            Prefill price data using your HVF Draw Tool's info panel.
            <Show when={!canAccessHvfTool()}>
              <Text textStyle="xs">
                Availble to those who have completed the one-year TMP and hold an active
                annual subscription
              </Text>
            </Show>
          </Text>
        </Grid>
        <Button
          disabled={!canAccessHvfTool()}
          onClick={() => props.setIsOpen(true)}
          colorPalette="jade"
          variant="solid"
          size="xs"
        >
          <ScanSearch />
          Price Data Extractor
        </Button>
      </Grid>
    </Card.Root>
  )
}
